import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import './MainUpdateAdmini.css';


function MainUpdateAdmini() {
    const [adminis, setAdminis] = useState([]);

    useEffect(() => {
        axios.get('https://school-web-server-eight.vercel.app/')
            .then(result => setAdminis(result.data))
            .catch(err => console.log(err))
    })


    // Delete card of Administrators
    const handleDeleteAdminis = async (id, imageName) => {
        try {
            await axios.delete(`https://school-web-server-eight.vercel.app/deleteUser/${id}`); //delete component form backend

            if (imageName && imageName !== "none_profile.jpg") {
                await axios.delete(`https://school-web-server-eight.vercel.app/${imageName}`); //delete file in directory that user store
            }
            window.location.reload();
            setAdminis(adminis.filter(user => user._id !== id)); // udpate to front that user have delete
        } catch (error) {
            console.log("error in delete method" + error);
        }
    }



    return (
        <div className="MainUpdateAdmini">
            <div className="main-panel">
                <div className="head-update-ad">
                    <Link to="createAdmini" className="add-button">เพิ่มข้อมูล</Link>
                    <div className="text-head-update-ad">
                        <h1>Administrators - คณะผู้บริหาร</h1>
                    </div>
                </div>
                <div className="show-update-ad">
                    {adminis.map((admini) => (
                        <div className='admini-card' key={admini._id}>
                            <img src={`https://school-web-server-eight.vercel.app/ImageAdmini/${admini.image}`} alt={admini.name}/>
                            <div className='info'>
                                <h3>{admini.name}</h3>
                                <p>{admini.position} {admini.acadStanding}</p>
                                {/* <p>{admini.acadStanding}</p> */}
                                <p>{admini.headOf}</p>
                            </div>
                            <div className='actions'>
                                <Link to={`updateAdmini/${admini._id}`} className='update-admini'>อัพเดทข้อมูล</Link>
                                <button className='delete-admini' onClick={() => handleDeleteAdminis(admini._id, admini.image)}>ลบข้อมูล</button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default MainUpdateAdmini
